import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useMemo } from 'react';

import { GlobalBreakdownParams, GlobalBreakdownResponse } from '../domain/types';
import { affiliateStatsService } from '../infra/affiliateStatsService';

interface UseAffiliateGlobalBreakdownParams extends GlobalBreakdownParams {
  projectId: string;
}

interface UseAffiliateGlobalBreakdownResult {
  breakdown: GlobalBreakdownResponse | null;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
}

export const useAffiliateGlobalBreakdown = ({
  projectId,
  ...params
}: UseAffiliateGlobalBreakdownParams): UseAffiliateGlobalBreakdownResult => {
  const {
    data: response,
    isError,
    isLoading,
    refetch,
  }: UseQueryResult<GlobalBreakdownResponse, Error> = useQuery({
    queryKey: ['affiliate-management', 'global-breakdown', projectId, params],
    queryFn: async () => {
      return affiliateStatsService.getGlobalBreakdown(projectId, params);
    },
    enabled: !!projectId,
  });

  const breakdown = useMemo(() => response ?? null, [response]);

  return {
    breakdown,
    isLoading,
    isError,
    refetch,
  };
};
